import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@mui/material';
import i18n from '../../i18n';

const ContactSupportDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
            <DialogTitle align="center">
                {i18n.t('text.contactSupport')}
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    margin="dense"
                    label={i18n.t('text.enterProblem')}
                    multiline
                    minRows={4}
                    placeholder={i18n.t('text.enterProblem')}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{i18n.t('buttons.cancel')}</Button>
                <Button onClick={onClose}>{i18n.t('buttons.send')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactSupportDialog;
